import React from 'react';
import styled from 'styled-components';

import { useStoreState } from 'easy-peasy';

import { nf } from '~/utils';
import { media } from '~/styles/Utils';

const Wrapper = styled.div`
  margin-top: 10px;
  opacity: ${(p) => (p.isActive ? 1 : 0.5)};
  transition: opacity 300ms;
  box-shadow: ${(p) =>
    p.isActive ? '0 2px 8px 4px rgba(0, 0, 0, 0.05)' : 'none'};
  padding: 10px;
  border-radius: 2px;
`;

const ResultSentence = ({ percentile, year, isRel, buttonActive }) => {
  const numberFormat = useStoreState((state) => state.app.numberFormat);
  const ySelector = useStoreState((state) => state.app.ySelector);

  const label = `${nf(percentile[ySelector], numberFormat)} ${
    isRel ? 'Prozent' : 'Euro'
  }`;

  return (
    <Wrapper isActive={!buttonActive}>
      <div>
        Dieser Haushalt gehört <strong>{year}</strong> zum{' '}
        <strong>{percentile[config.columns.PERCENTAGE]}. Prozent</strong> der
        Einkommensverteilung in Deutschland. Dieses Prozent zahlt in diesem Jahr
        je Erwachsenem durchschnittlich <strong> {label}</strong>{' '}
        {isRel ? 'Einkommensteuern' : 'Einkommensteuer'}.
      </div>
    </Wrapper>
  );
};

export default ResultSentence;
